var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._b(
      {
        attrs: {
          filterable: "",
          clearable: "",
          remote: "",
          "remote-method": _vm.remoteMethod,
          "popper-class": "el-select-thick-scrollbar"
        },
        model: {
          value: _vm.curSelect,
          callback: function($$v) {
            _vm.curSelect = $$v
          },
          expression: "curSelect"
        }
      },
      "el-select",
      _vm.$attrs,
      false
    ),
    _vm._l(_vm.optionsList, function(item) {
      return _c("el-option", {
        key: item.id,
        attrs: { label: item.name, value: item.id }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dee06ee4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dee06ee4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/projectComponents/ChengBenZhongXin.vue
// module id = t3+/
// module chunks = 38